import { api, parseApiError } from './api';
import type { Notification, NotificationsListResponse } from '@/types/notification';

export const notificationsService = {
  /**
   * Get list of notifications for the authenticated user
   */
  async getNotifications(unreadOnly: boolean = false): Promise<NotificationsListResponse> {
    try {
      const params: Record<string, string> = {};
      if (unreadOnly) params.unread_only = 'true';

      const response = await api.get<NotificationsListResponse>('/api/notifications', { params });
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Mark a single notification as read
   */
  async markAsRead(id: string): Promise<Notification> {
    try {
      const response = await api.put<Notification>(`/api/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<{ count: number }> {
    try {
      const response = await api.put<{ count: number }>('/api/notifications/read-all');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default notificationsService;
